﻿import { formatPhoneNumber, PhoneNumberStatus } from "./Lib/OpusPortalUI";
import * as bootstrap from "bootstrap";

export function reformatPhoneNumber(target: HTMLInputElement): void {
    const formatPhoneNumberResult = formatPhoneNumber(target.value);

    if (formatPhoneNumberResult.InputStatus === PhoneNumberStatus.Reformatted) {
        target.value = formatPhoneNumberResult.Result;
    }
}

export function showAlertIfNotDismissed(alertId: string, localStorageKey: string, localStorageValue: string) {
    const wasDismissed = localStorage.getItem(localStorageKey);

    if (wasDismissed !== localStorageValue) {
        const alert = document.getElementById(alertId);
        if (alert instanceof HTMLElement) {
            alert.style.display = "block";
        }
    }
}

export function dismissAlertAndPersist(alertId: string, localStorageKey: string, localStorageValue: string) {
    const bsAlert = new bootstrap.Alert('#' + alertId);
    bsAlert.close();

    localStorage.setItem(localStorageKey, localStorageValue);
}

export function throwUnhandledException(): void {
    throw new DOMException("test message", "test name")
}

export function setEnvironment(environment: string): void {
    (window as any).environment = environment;
}

export function getEnvironment(): string {
    const environment = ((window as any).environment as string);
    return environment;
}

export function initializeAttachmentModal(modalId: string, imageId: string, imageLoadingId: string): void {
    const modal = document.getElementById(modalId);
    const image = document.getElementById(imageId);
    const imageLoading = document.getElementById(imageLoadingId);

    if (modal && image && imageLoading) {
        modal.addEventListener("shown.bs.modal", () => {
            const src = image.getAttribute("data-src");
            if (src) {
                image.setAttribute("src", src);
                image.addEventListener("load", () => {
                    if (imageLoading) {
                        imageLoading.style.display = "none";
                    }
                });
            }
        });
    }
}

export function initPopover(targetElementId: string, popoverContentIdOrElement: string | HTMLElement, popoverTitle: string) {
    const targetElement = document.getElementById(targetElementId);
    const popoverContent = (typeof popoverContentIdOrElement === "string")
        ? document.getElementById(popoverContentIdOrElement)
        : popoverContentIdOrElement;

    if (targetElement && popoverContent) {
        const opts: Partial<bootstrap.Popover.Options> = {
            content: popoverContent.innerHTML,
            html: true,
            title: popoverTitle,
            trigger: "hover",
            placement: "right",
            sanitize: false
        };

        new bootstrap.Popover(targetElement, opts);
    }
}

export function initializePopovers(parentSelector?: string) {
    const selector = parentSelector ? `${parentSelector} [data-bs-toggle='popover']` : "[data-bs-toggle='popover']";

    const popoverTriggerList = document.querySelectorAll(selector);

    popoverTriggerList.forEach((element: Element, key, parent) => {
        if (element.hasAttribute("data-bs-content-id")) {
            const opts: Partial<bootstrap.Popover.Options> = {
                html: element.hasAttribute("data-bs-html") && element.getAttribute("data-bs-html") === "true",
                title: element.getAttribute("data-bs-title") ?? element.getAttribute("title") ?? "",
                content: document.getElementById(element.getAttribute("data-bs-content-id")!)!.innerHTML,
                customClass: element.getAttribute("data-bs-custom-class") ?? ""
            };
            new bootstrap.Popover(element, opts);
        } else {
            new bootstrap.Popover(element);
        }
    });
}

export function initializeTooltips() {
    const tooltipTriggerList = document.querySelectorAll("[data-bs-toggle='tooltip']")
    tooltipTriggerList.forEach((element: Element, key, parent) => {
        new bootstrap.Tooltip(element);
    });
}

function getAllFormSubmitButtons(): NodeListOf<HTMLButtonElement | HTMLInputElement> {
    return document.querySelectorAll<HTMLButtonElement | HTMLInputElement>(
        "form button[type='submit'], form button:not([type]), form input[type='submit']");
}

export function disableSubmitButtonsOnFormPost(): void {
    // Add indicators
    getAllFormSubmitButtons().forEach((button: HTMLButtonElement | HTMLInputElement) => {
        if (button.querySelector(".htmx-indicator")) {
            // If the button already has an indicator, skip adding one
            return;
        }
        const spinner = document.createElement("span");
        spinner.className = "htmx-indicator far fa-spinner fa-spin ms-1";
        button.appendChild(spinner);
    });

    const allForms = document.querySelectorAll("form");

    allForms.forEach((form: HTMLFormElement) => {
        form.addEventListener("submit", (ev: SubmitEvent): any => {
            getAllFormSubmitButtons().forEach((button: HTMLButtonElement | HTMLInputElement) => {
                button.disabled = true;
            });

            if (ev.submitter instanceof HTMLButtonElement) {
                const spinner = ev.submitter.querySelector<HTMLElement>(".htmx-indicator");
                if (spinner)
                    spinner.style.display = "inline-block";
            }
        });
    });
}

disableSubmitButtonsOnFormPost();
initializePopovers();
initializeTooltips();
